<!-- ブックをis_expired=trueにするダイアログ-->
<template>
  <div>
    <ItemDialog ref="bookChangeToUsed" image-type="alert" :initial-open="false">
      <template #content-area>
        <h2>利用を終了すると効力を失います</h2>
        <p class="text-center">本当に利用を終了しますか？</p>
      </template>

      <template #button-area>
        <ItemButton
          label="OK"
          action-type="btn-primary"
          @clicked="passChangeToUsed()"
        />
        <ItemButton
          label="キャンセル"
          action-type="btn-cancel"
          @clicked="closeDialog"
        />
      </template>
    </ItemDialog>

    <!-- ローディングダイアログ -->
    <DialogLoading ref="DialogLoading" />
  </div>
</template>

<script>
import DialogLoading from "@/views/Components/Organisms/Common/Dialog/DialogLoading";

import { computed, ref } from "vue";
import { useStore } from "vuex";
import { useRoute } from "vue-router";

import API from "@/API";

export default {
  name: "DialogBookChangeToUsed",
  components: {
    DialogLoading: DialogLoading,
  },
  setup() {
    const store = useStore();
    const route = useRoute();

    const book = computed(() => store.getters["ticketing/book"]);

    const bookChangeToUsed = ref(null);
    const DialogLoading = ref(null);

    const openDialog = () => {
      bookChangeToUsed.value.open();
    };

    const closeDialog = () => {
      bookChangeToUsed.value.close();
    };

    const passChangeToUsed = async () => {
      closeDialog();
      DialogLoading.value.openDialog();
      await API.usedBook(book.value.id);
      await API.getMyticketDetail(route.params.book_group_id);
      if (DialogLoading.value) {
        DialogLoading.value.closeDialog();
      }
    };

    return {
      bookChangeToUsed,
      DialogLoading,
      passChangeToUsed,
      openDialog,
      closeDialog,
    };
  },
};
</script>
